import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id:uuid,
    valueType: 'modal',
    pType:"baseFormComponent", // 父级分类
    MoadlProps: {
      title:"title"
    },
  }
};
